import { SpiritedDarkTheme } from "../.internal/themes/SpiritedDarkTheme";
export default SpiritedDarkTheme;
